import React from "react";
import { Chip, Collapse, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from "@mui/icons-material";
import DocTypeAccordion from "../DocTypeAccordion";
import DocumentsTable from "../DocumentsTable";
import CloudDownloadIcon from "../../../../icons/CloudDownloadIcon";

const SectionAccordion = ({
  section,
  documents,
  docTypes,
  onExportSection,
  onExportDocType,
  defaultOpen,
  expandedDocTypeName,
  highlightDocumentId,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(Boolean(defaultOpen));

  React.useEffect(() => {
    setOpen(Boolean(defaultOpen));
  }, [defaultOpen]);

  if (documents.length === 0) return null;

  return (
    <div>
      <div className={classes.trigger} onClick={() => setOpen(!open)}>
        {open ? <ExpandLessIcon className={classes.arrow} /> : <ExpandMoreIcon className={classes.arrow} />}
        <Chip
          label={section.label}
          className={classes.chip}
          style={{ color: section.color, backgroundColor: section.bg }}
        />
        <div className={classes.spacer} />
        <IconButton
          size="small"
          className={classes.downloadIcon}
          onClick={(e) => {
            e.stopPropagation();
            onExportSection?.(section.key);
          }}
        >
          <CloudDownloadIcon />
        </IconButton>
      </div>
      <Collapse in={open}>
        <div className={classes.content}>
          {docTypes.length > 0
            ? docTypes.map((typeName) => (
                <DocTypeAccordion
                  key={typeName}
                  typeName={typeName}
                  sectionKey={section.key}
                  documents={documents.filter((d) => d.type_name === typeName)}
                  onExportDocType={onExportDocType}
                  defaultOpen={Boolean(defaultOpen && expandedDocTypeName === typeName)}
                  highlightDocumentId={highlightDocumentId}
                />
              ))
            : <DocumentsTable documents={documents} sectionKey={section.key} highlightDocumentId={highlightDocumentId} />
          }
        </div>
      </Collapse>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  trigger: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "0 16px",
    minHeight: 56,
    borderRadius: 8,
    backgroundColor: "#FAFAFA",
  },
  arrow: { color: "#71717A", marginRight: 8 },
  chip: {
    height: 28,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    "& .MuiChip-label": { padding: "0 14px" },
  },
  spacer: { flex: 1 },
  downloadIcon: { color: "#A1A1AA" },
  content: { paddingLeft: 48, paddingTop: 16, display: "flex", flexDirection: "column", gap: 16 },
}));

export default SectionAccordion;
